import { render, staticRenderFns } from "./Slot.vue?vue&type=template&id=55dae9be&scoped=true&"
import script from "./Slot.vue?vue&type=script&lang=js&"
export * from "./Slot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dae9be",
  null
  
)

export default component.exports